import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { Button, Input, message, Select } from 'antd';
import { useStoreApi } from 'reactflow';
import type { MirrorNodeType } from './types';
import type { InputVar, NodePanelProps } from '../../types';
import useConfig from './use-config';
import Field from '../_base/components/field';

import InputVarTypeIcon from '../_base/components/input-var-type-icon';
import { BlockEnum, InputVarType } from '../../types';

const Panel: FC<NodePanelProps<MirrorNodeType>> = ({ id, data }) => {
  const store = useStoreApi();
    const {
    inputs,
    handleHashChange,
    mirrorNodeChange
  } = useConfig(id, data);
  const [nodeOptions, setNodeOptions] = useState<{ label, value }[]>([]);

  useEffect(() => {
    const { getNodes } = store.getState();
    const nodes = getNodes();
    const assignmentNodes = nodes.filter((node) => (node.data.type === BlockEnum.AssignmentOnline || node.data.type === BlockEnum.AssignmentOffline));
    const items = assignmentNodes.map(item => {
      return {
        label: item.data.title,
        value: item.id
      }
    })
    setNodeOptions(items)
  }, [])

  return (
    <div className="mt-2">
      <div className="space-y-4 px-4 pb-2">
        <Field title="选择节点">
          <div className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white pr-2.5 shadow-xs hover:shadow-md">
            <div className="flex w-0 grow items-center space-x-1 bg-components-input-bg-normal">
              <Select
                className="w-full"
                bordered={false}
                placeholder="请选择"
                allowClear
                options={nodeOptions}
                value={inputs.mirrorNode?.id}
                onChange={(value, option: any) => {
                  mirrorNodeChange({
                    id: value,
                    name: option.label
                  })
                }}
              />
            </div>
            <div className="ml-2 flex shrink-0 items-center">
              <InputVarTypeIcon
                type={InputVarType.number}
                className="h-3.5 w-3.5 text-gray-500"
              />
            </div>
          </div>
        </Field>
      </div>
    </div>
  );
};

export default React.memo(Panel);
